<template>
  <div v-if="count > 0" class="col-auto">
    <i class="text-muted">{{view}} Count: {{count}}</i>
  </div>
  <div class="col-auto">
    <button type="button" class="btn btn-sm btn-success" @click="$emit('new')" >
      <i class="bi bi-plus-lg"></i> Add {{view}}
    </button>
  </div>
</template>

<script setup>
import vTooltip from '@/directives/tooltip';
defineProps({
  view: String,
  count: Number,
});
defineEmits(['new']);
</script>

<style scoped>
/* .pointer { cursor: pointer; }
.action { height: 20px; width: auto; } */
</style>
